import { useEffect, useState } from "react";
import { Package } from "lucide-react";
import { cn } from "@/lib/utils";

/** Imagem com fallback controlado por estado (nunca manipula o DOM direto). */
export function SafeImage({
  src,
  alt,
  className,
  wrapperClassName,
  fallbackLabel = "Foto em breve",
  loading = "lazy",
  ...rest
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const showFallback = !src || failed;

  return (
    <div className={cn("relative overflow-hidden bg-secondary/50", wrapperClassName)} {...rest}>
      {showFallback ? (
        <div className="flex h-full w-full flex-col items-center justify-center gap-1.5 text-muted-foreground">
          <Package className="h-6 w-6" />
          <span className="px-2 text-center text-[10px] uppercase tracking-wide">{fallbackLabel}</span>
        </div>
      ) : (
        <img
          key={src}
          src={src}
          alt={alt}
          loading={loading}
          decoding="async"
          onError={() => setFailed(true)}
          className={cn("h-full w-full object-cover", className)}
        />
      )}
    </div>
  );
}
